import app from 'flarum/common/app';
import { BooleanGambit } from 'flarum/common/query/IGambit';
export default class SuspendedGambit extends BooleanGambit {
  key() {
    return app.translator.trans('flarum-suspend.lib.gambits.users.suspended.key', {}, true);
  }
  canonicalKey() {
    return 'suspended';
  }
  filterKey() {
    return 'suspended';
  }
  enabled() {
    return !!app.session.user && app.forum.attribute('canSuspendUsers');
  }
}
flarum.reg.add('flarum-suspend', 'common/query/users/SuspendedGambit', SuspendedGambit);